/**
 * Created by jv on 25/05/2018.
 */
import LanguageManager from "Sources/services/language-manager";

function getText()
{
  return {
    menu: {
      title: LanguageManager.getValueForKey("games.carrot.game.title"),
      controlsDescription: [
        LanguageManager.getValueForKey("games.carrot.game.description.line1"),
        LanguageManager.getValueForKey("games.carrot.game.description.line2")
      ],
      powerUps: {
        shield: {
          title: LanguageManager.getValueForKey("games.carrot.game.powerups.shield.title"),
          description: [ LanguageManager.getValueForKey("games.carrot.game.powerups.shield.description.line1"), LanguageManager.getValueForKey("games.carrot.game.powerups.shield.description.line2") ]
        },
        springball: {
          title: LanguageManager.getValueForKey("games.carrot.game.powerups.springball.title"),
          description: [ LanguageManager.getValueForKey("games.carrot.game.powerups.springball.description.line1"), LanguageManager.getValueForKey("games.carrot.game.powerups.springball.description.line2") ]
        },
        rocketCake: {
          title: LanguageManager.getValueForKey("games.carrot.game.powerups.rocket_cake.title"),
          description: [ LanguageManager.getValueForKey("games.carrot.game.powerups.rocket_cake.description.line1"), LanguageManager.getValueForKey("games.carrot.game.powerups.rocket_cake.description.line2") ]
        },
        magnet: {
          title: LanguageManager.getValueForKey("games.carrot.game.powerups.magnet.title"),
          description: [ LanguageManager.getValueForKey("games.carrot.game.powerups.magnet.description.line1"), LanguageManager.getValueForKey("games.carrot.game.powerups.magnet.description.line2") ]
        }
      },
      playBtn: LanguageManager.getValueForKey("games.carrot.game.start.btn"),
      resumeBtn: LanguageManager.getValueForKey("games.carrot.game.resume.btn")
    },
    gameOver: {
      title: LanguageManager.getValueForKey("games.carrot.game.gameover.title"),
      highScore: LanguageManager.getValueForKey("games.carrot.game.gameover.highscore"),
      replayBtn: LanguageManager.getValueForKey("games.carrot.game.gameover.replay.btn")
    }
  };
}

export default getText;



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/config/text.js